import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDiscourseComponent } from './simple-icons-discourse.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDiscourseComponent ],
    exports:      [ SimpleIconsDiscourseComponent ],
    bootstrap:    []
})
export class SimpleIconsDiscourseModule {}
